import type { ElevateAccount, ElevateAccountInput, ElevateIntegration } from "@/schema/elevate-integration"

import { apiContextFetch, type ApiContext } from "@/hooks/api/base"

export const fetchElevateAccounts = (context: ApiContext) =>
  apiContextFetch<ElevateAccount[]>(context, "elevate_account_credentials")
export const fetchElevateIntegrations = (context: ApiContext) =>
  apiContextFetch<ElevateIntegration[]>(context, "elevate_integrations")
export const saveElevateAccount = (context: ApiContext, input: ElevateAccountInput, id?: string) =>
  apiContextFetch<ElevateAccount>(context, `elevate_account_credentials${id ? `/${id}` : ""}`, {
    method: id ? "PUT" : "POST",
    body: JSON.stringify({ elevate_account_credential: input }),
  })
